import licenseModule from '../../license.module';

export default licenseModule.component('licenseRenewLicenseResult', {
    template: require('./licenseRenewLicenseResult.component.html'),
    controller: licenseRenewLicenseResultComponent,
    bindings: {
        licensePayload: '<',
        licenseHideButton: '<'
    }
});

function licenseRenewLicenseResultComponent() {
    var vm = this;
    vm.$onInit = function() {
        vm.asProgressSteps = {
            steps: [
                {
                    label: 'Generate License',
                    value: 1
                },
                {
                    label: 'Apply License',
                    value: 2
                },
                {
                    label: 'Apply Receipt',
                    value: 3
                }
            ],
            currentStep: 1
        };
    };

    vm.$onChanges = function() {
        if (vm.licensePayload != undefined && vm.licensePayload != '') {
            vm.payload = vm.licensePayload;
        }
        if (vm.licenseHideButton != undefined && vm.licenseHideButton != '') {
            vm.hidecopybutton = vm.licenseHideButton;
        }
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-renew-license-result/licenseRenewLicenseResult.component.js